module.exports = __webpack_public_path__ + "static/process1-7f25a33490ca0ebc23609e825fd33507.png";